// TRN-6921 — built as components/Authorization/components/LoginBrandPanel.js for the Login page's split-screen
// layout; extracted here in TRN-6922 so the new email-registration page (components/Registration/Email) can
// reuse the exact same brand panel instead of maintaining its own copy.
import { useContext } from 'react';
import i18nContext from 'components/i18n-context';
import { ReactComponent as LogoWhite } from 'assets/logo-white.svg';
import { ReactComponent as ShieldCheckIcon } from 'assets/iconButtons/shield-check.svg';
import { ReactComponent as GlobeIcon } from 'assets/iconButtons/globe-outline.svg';
import { ReactComponent as ClockIcon } from 'assets/iconButtons/clock-outline.svg';
import { ReactComponent as IsoBadge } from 'assets/iso-badge.svg';
import AuthMobileApp, { AUTH_MOBILE_APP_VARIANTS } from 'components/common/AuthMobileApp';
import './AuthBrandPanel.scss';

const FEATURES = [
  {
    Icon: ShieldCheckIcon,
    titleKey: 'login.brand.feature.security.title',
    descriptionKey: 'login.brand.feature.security.description'
  },
  {
    Icon: GlobeIcon,
    titleKey: 'login.brand.feature.transfers.title',
    descriptionKey: 'login.brand.feature.transfers.description'
  },
  {
    Icon: ClockIcon,
    titleKey: 'login.brand.feature.onboarding.title',
    descriptionKey: 'login.brand.feature.onboarding.description'
  }
];

const AuthBrandPanel = () => {
  const i18n = useContext(i18nContext);

  return (
    <div className={'auth-brand-panel'}>
      <div className={'auth-brand-panel__inner'}>
        <div className={'auth-brand-panel__inner__content'}>
          <a
            href={process.env.REACT_APP_LINK_HOME_PAGE}
            target={'_blank'}
            rel={'noreferrer'}
            className={'auth-brand-panel__logo'}
          >
            <LogoWhite />
          </a>

          <div className={'auth-brand-panel__intro'}>
            <h2 className={'auth-brand-panel__headline'}>{i18n.getMessage('login.brand.headline')}</h2>
            <p className={'auth-brand-panel__subheadline'}>{i18n.getMessage('login.brand.subheadline')}</p>
          </div>

          <ul className={'auth-brand-panel__features'}>
            {FEATURES.map(({ Icon, titleKey, descriptionKey }) => (
              <li className={'auth-brand-panel__feature'} key={titleKey}>
                <div className={'auth-brand-panel__feature-icon'}>
                  <Icon />
                </div>
                <div>
                  <p className={'auth-brand-panel__feature-title'}>{i18n.getMessage(titleKey)}</p>
                  <p className={'auth-brand-panel__feature-description'}>{i18n.getMessage(descriptionKey)}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>

        {/* TRN-7538: pinned to the bottom of the panel — the ISO block as its footer, the app QR codes above it. */}
        <div className={'auth-brand-panel__bottom'}>
          <AuthMobileApp variant={AUTH_MOBILE_APP_VARIANTS.QR} />

          <div className={'auth-brand-panel__badge'}>
            <div className={'auth-brand-panel__badge-divider'} />
            <div className={'auth-brand-panel__badge-content'}>
              <IsoBadge className={'auth-brand-panel__badge-box'} />
              <p className={'auth-brand-panel__badge-description'}>
                {i18n.getMessage('login.brand.badge.description')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthBrandPanel;
